import React, { useState } from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reusable/Spinner";
import Skeleton from "../../components/Reusable/Skeleton";
const EditStatusComponent = loadable(
  () => import("../../components/RtvBranchSetting")
);
const RTVBranchStatusEdit = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState<any>([]);
  const handleEditStatusChange = (value: any) => {
    setDefaultValue(value);
  };
  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {},
  });
  const { data: gridData, isLoading } = useGetHook({
    queryKey: [`rtv-status`],
    url: `${APIS.RTV_BRANCH}`,
    params: {
      is_active: true,
    },
  });

  const { mutateAsync, isLoading: patchLoading } = usePatchHook({
    queryKey: ["rtv-status"],
    navigateURL: "",
  });
  const handleOpenEditPopup = (item: any) => {
    setSelectedItem(item);
    setDefaultValue([...item?.status_id]);
    setOpenEditPopup(true);
  };

  const handleStatusInclude = async (event: any) => {
    event.preventDefault();
    const url = `${APIS.RTV_BRANCH}${selectedItem?.id}/`;
    let formData = {
      status_id: defaultValue?.map((item: any) => item.id) ?? [],
    };
    try {
      const rest = await mutateAsync({ url, formData });
      if (rest.status === 200) {
        setOpenEditPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <EditStatusComponent
          gridData={gridData}
          statusList={statusList}
          patchLoading={patchLoading}
          handleStatusInclude={handleStatusInclude}
          setSelectedItem={setSelectedItem}
          setOpenEditPopup={setOpenEditPopup}
          openEditPopup={openEditPopup}
          handleEditStatusChange={handleEditStatusChange}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handleOpenEditPopup={handleOpenEditPopup}
        />
      )}
    </>
  );
};
export default RTVBranchStatusEdit;
